import { createSlice } from '@reduxjs/toolkit';
import {} from './atsJobsActions';

// todo: need to remove once api is done
const reducerName = 'atsJobs';
const initialState = {
  searchTerm: null,
  filters: {
    office_ids: undefined,
    department_ids: [],
    job_statuses: undefined,
    user_ids: [],
    eeoc_data_collection: [],
    isFilterApplied: false,
    feConfig: [], // For new filter format
    beConfig: {}, // For backend config
  },
  page: {
    number: 0,
    offset: 0,
    limit: 20,
  },
  sort: {
    label: 'Created date (Newest to oldest)',
    value: 'DESC',
    element: 'created_at',
    order: 'DESC',
  },
  currentView: 'card',
  updateJob: {
    isLoading: false,
    data: {},
    status: undefined,
    errors: undefined,
    flash: undefined,
  },
  createJob: {
    isLoading: false,
    data: {},
    status: undefined,
    errors: undefined,
    flash: undefined,
  },
  getAllJobs: {
    isLoading: false,
    data: {},
    status: undefined,
    errors: undefined,
    flash: undefined,
  },
};

const hasActiveFilters = (filters = {}) =>
  Object.keys(filters.beConfig || {}).length > 0 ||
  (filters.feConfig || []).length > 0;

const { reducer, actions: atsJobsActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    resetJobState: (state, { payload: { key } }) => {
      state[key] = { ...initialState[key] };
    },

    setCurrentView: (state, { payload: { view } }) => {
      state.currentView = view;
      // state.searchTerm = '';
    },

    applySort: (state, { payload }) => {
      state.sort = payload;
    },

    applyFilter: (state, { payload }) => {
      const { key, value, feConfig, beConfig, isNewFilter } = payload;

      // Handle new filter format
      if (isNewFilter) {
        if (feConfig) {
          state.filters.feConfig = feConfig;
        }
        if (beConfig) {
          state.filters.beConfig = beConfig;
        }
        state.filters.isFilterApplied = true;
        state.page = { ...initialState.page };
        return;
      }

      // Handle old filter format
      state.filters[key] = value;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    setFiltersData: (state, { payload }) => {
      state.filters.feConfig = payload;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    applyFilters: (state, { payload }) => {
      for (const item of payload) {
        const { key, value } = item;
        state.filters[key] = value;
        state.page = { ...initialState.page };
        state.filters.isFilterApplied = true;
      }
    },

    applyPage: (state, { payload }) => {
      const { page } = payload;
      state.page.number = page;
      state.page.offset = state?.page?.number * state?.page?.limit;
    },

    clearFilter: (state, { payload }) => {
      const { key } = payload;
      state.filters[key] = initialState.filters[key];
      delete state.filters.beConfig?.[key];
      state.filters.feConfig = (state.filters.feConfig || []).filter(
        (item) => item?.filter_by?.value !== key
      );
      state.page = { ...initialState.page };
      state.filters.isFilterApplied =
        hasActiveFilters(state.filters) || state.searchTerm?.length > 0;
    },

    clearAllFilter: (state) => {
      state.filters = { ...initialState.filters };
      state.filters.feConfig = [];
      state.filters.beConfig = {};
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = false;
    },

    clearData: (state) => {
      state.sort = { ...initialState.sort };
      state.currentView = initialState.currentView;
      state.searchTerm = '';
    },

    setLoadingState: (state, { payload }) => {
      const { key, isLoading } = payload || {};
      if (state[key]) {
        state[key].isLoading = isLoading;
      }
    },

    applySearch: (state, { payload }) => {
      const searchTerm = payload?.searchTerm;
      state.searchTerm = searchTerm;
      state.page = { ...initialState.page };
      // Emptying the search box must not read as "no filters" — that wipes the
      // user's stored filters and shows the create-your-first-job empty state.
      state.filters.isFilterApplied =
        searchTerm?.length > 0 || hasActiveFilters(state.filters);
    },

    setApiData: (state, { payload = {} }) => {
      const { key, data, status, errors, isLoading, flash } = payload || {};
      if (state[key]) {
        state[key].data = data;
        state[key].isLoading = isLoading;
        state[key].status = status;
        state[key].flash = flash;
        state[key].errors = errors;
      }
    },
  },
});

export { atsJobsActions };
export default reducer;
